import styled from 'styled-components';

export const EmptyListPlaceholder = styled.div`
  display: flex;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
